import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setToken(data.token);
        setUser(data.user);
        window.history.replaceState({}, "", "/orders");
        toast.success(`Welcome, ${data.user.name}!`);
        nav("/orders", { state: { user: data.user }, replace: true });
      } catch {
        toast.error("Google login failed");
        nav("/login");
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto" />
        <div className="mt-4 text-slate-600">Signing you in…</div>
      </div>
    </div>
  );
};
